import { createFileRoute } from '@tanstack/react-router';
import { TrustScorePage } from '../../features/trust';

export const Route = createFileRoute('/portal/trust')({ component: TrustScorePage });
